import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { graphql, Link, useStaticQuery } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
import useScreenSize from '../hooks/useScreenSize';

const NewsCarousel = ({ heading, backgroundColor, townName }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    rows: 1,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 10000,
    arrows: true,
    dotsClass: 'slick-dots slick-thumb slick-active',
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
          dotsClass: 'slick-dots slick-thumb slick-active',
        },
      },
      {
        breakpoint: 658,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          dotsClass: 'slick-dots slick-thumb slick-active',
        },
      },
    ],
  };

  const screenSize = useScreenSize();

  const data = query();
  const articles = data.allDatoCmsNewsArticleModel.nodes;
  const image = data.defaultNewsSvg.publicURL;
  const blogs = data.allDatoCmsBlogArticleModel.nodes;

  const sliderData = articles.concat(blogs);
  sliderData.sort((object1, object2) => {
    return new Date(object2.publishedDate) - new Date(object1.publishedDate);
  });

  return (
    <div className="bootstrap">
      <div className={`article-card-section ${backgroundColor ?? 'Black'}`}>
        {heading ? (
          <div className="article-card-header">
            <LitStructuredText data={heading} basic />{' '}
            {townName && <h3>{townName}</h3>}
          </div>
        ) : (
          <h3> Latest News and Blogs </h3>
        )}
        <div className="article-card-container">
          <Slider {...settings}>
            {sliderData
              .slice(0, screenSize.width > 1200 ? 13 : 6)
              .map(
                (
                  {
                    title,
                    previewText,
                    content,
                    slug,
                    category,
                    publishedDate,
                    previewImage,
                    contentWordCounter,
                  },
                  i,
                ) => {
                  const readTime = JSON.parse(contentWordCounter);

                  return (
                    <div className="article-card" key={i}>
                      <div className="article-card-inner">
                        <div className="article-card-image">
                          {/* PurgeCSS include: card-news-image, card-blog-image */}
                          <LitImage
                            image={previewImage}
                            alt={title}
                            className="card-blog-image"
                            loading="lazy"
                          />
                        </div>
                        <div className="article-card-content">
                          <span className="article-card-category">
                            {category?.name ? category.name : 'Blog'}
                          </span>
                          <Link
                            to={
                              category?.name
                                ? `/news/${slug}/`
                                : `/blog/${slug}`
                            }
                            aria-label={title}
                            title={title}
                          >
                            {' '}
                            <p className="article-card-title">{title}</p>
                          </Link>
                          <div className="article-card-details">
                            <p className="article-card-date ">
                              {publishedDate &&
                                publishedDate.replace(
                                  /(\d{4})\-(\d{2})\-(\d{2}).*/,
                                  '$3/$2/$1',
                                )}
                            </p>
                            <span>|</span>
                            <p className="article-card-time">
                              {readTime?.readingTime}
                            </p>
                          </div>
                          <Link
                            to={
                              category?.name
                                ? `/news/${slug}/`
                                : `/blog/${slug}`
                            }
                            className="button"
                            title="Read more"
                            aria-label="Read more"
                          >
                            Read more
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                },
              )}
          </Slider>{' '}
        </div>
      </div>
    </div>
  );
};

export default NewsCarousel;

const query = () => {
  return useStaticQuery(graphql`
    query {
      allDatoCmsNewsArticleModel(
        limit: 1000
        sort: { fields: publishedDate, order: DESC }
      ) {
        nodes {
          contentWordCounter
          id
          slug
          title
          previewText
          publishedDate
          previewImage {
            gatsbyImageData(width: 300)
          }
          content {
            value
          }
          category {
            name
          }
        }
      }
      allDatoCmsBlogArticleModel {
        nodes {
          contentWordCounter
          seoTitle
          seoDescription
          slug
          publishedDate
          previewText
          previewImage {
            gatsbyImageData(width: 300)
          }
          title
          content {
            value
          }
        }
      }
      defaultNewsSvg: file(
        relativePath: { eq: "news-images/news_default.svg" }
      ) {
        name
        relativePath
        extension
        publicURL
      }
      blueLinesLeft: file(
        relativePath: { eq: "home-images/anyQuestionsLinesLeft.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      blueLinesRight: file(
        relativePath: { eq: "home-images/anyQuestionsLinesRight.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
    }
  `);
};
